/**
 * Presence-Aware Select Component
 *
 * Select field with presence indicators showing who is currently editing.
 * Extends shadcn/ui Select component with collaboration features.
 */

import * as React from "react"
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "./select"
import { PresenceBadge, getPresenceFieldStyle } from "./presence-badge"

const PresenceSelect = React.forwardRef(
  ({
    children,
    placeholder,
    editor = null, // { user_id, user_name, user_initials, timestamp }
    isCurrentUser = false,
    ...props
  }, ref) => {
    const showPresence = editor && !isCurrentUser;

    return (
      <div className="relative w-full">
        <Select {...props}>
          <SelectTrigger
            ref={ref}
            className="transition-shadow duration-200"
            // Only styled while someone else holds the field, so the trigger's
            // own focus-visible ring is left intact the rest of the time.
            style={showPresence ? getPresenceFieldStyle(editor.user_id) : undefined}
          >
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          {children}
        </Select>

        {showPresence && <PresenceBadge editor={editor} className="z-50" />}
      </div>
    )
  }
)

PresenceSelect.displayName = "PresenceSelect"

// Re-export other Select components for convenience
export {
  PresenceSelect,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue
}
